import React from "react";
import st from "../styles/Ui.module.scss"
import clsx from "clsx";
import ChevroneIcon from "@/svg/ChevroneIcon.tsx";
import LangSwitcherDesktop from "@/ui/LangSwitcherDesktop.tsx";
import {useTranslation} from "react-i18next";
import { useNavigate  } from 'react-router-dom';
import Images from "@/utils/images.ts";
import DashboardClass from "@/utils/dashboard_class.ts";
import useAuth from "@/hooks/auth.ts";

interface Props {
    light?:boolean
    back?:boolean
}

const DashboardHeader:React.FC<Props> = ({light, back}) => {
    const navigate = useNavigate();
    const {t} = useTranslation()
    const auth = useAuth()
    
    return (
        <div className={clsx(st.dashboard_header, light && st.light)}>
            
            <div className={st.inner}>
                
                <div
                    onClick={() => {
                        if(back) {
                            navigate(-1)
                            return
                        }
                        window.open(import.meta.env.VITE_WEBSITE_URL, "_self")
                    }}
                    className={clsx(st.sides, st.left)}
                >
                    <ChevroneIcon />
                    <span>
                        {back ? t("back") : t("back_to_site")}
                    </span>
                </div>
                
                <div
                    onClick={() => {!auth.isAuth() ? navigate(DashboardClass.login_routes.LoginStep1) : navigate(DashboardClass.login_routes.Home)}}
                    className={clsx(st.sides, st.center)}
                >
                    <img
                        src={Images.logos.LogoSimple}
                        alt={"logo"}
                        style={{
                            height: "auto"
                        }}
                        width={91}
                    />
                </div>
                
                <LangSwitcherDesktop className={clsx(st.switcher, st.sides, st.right)} />
            </div>
        
        </div>
    )
}

export default DashboardHeader